__webpack_require__.p = "/jeremy-huynh-portfolio2.0/";